import Loadable from 'react-loadable';

const LoadablePasswordRecoveryWizard = Loadable({
  loader: () => import(/* webpackChunkName: "PasswordRecovery" */ './Wizard'),
  modules: ['./PasswordRecovery'],
  loading: () => null
});

export default LoadablePasswordRecoveryWizard;
